<template>
  <v-dialog
    :model-value="open"
    class="redeem_modal-dialog"
    @update:model-value="$emit('update:open', $event)"
    content-class="redeem_modal"
    :scrim="'#212121'"
    :opacity="0.65"
    persistent
    scrollable
  >
    <v-card class="tickets_modal transparent redeem_modal redeem_modal-dialog__card">
      <v-card-title
        class="pa-5 flex-column v-header--fixed"
        :class="modal.heading ? 'white' : 'primary pb-0'"
      >
        <div class="d-flex justify-end" style="width: 100%">
          <v-btn
            id="product_ticketsmodal_X_btn"
            class="gtm-click"
            icon
            size="32"
            @click="$emit('close-modal')"
          >
            <icon :dark="!modal.heading" height="14" width="14">
              close-x
            </icon>
          </v-btn>
        </div>
        <div>
          <icon
            v-if="modal.icon"
            class="d-block mx-auto mt-n4 mb-2"
            fill="primary, primary"
            height="54"
            width="54"
          >
            {{ modal.icon.name }}
          </icon>
          <h3 v-if="modal.heading" class="text-center mb-2">
            {{ modal.heading }}
          </h3>
        </div>
      </v-card-title>

      <v-card-text class="pa-0">
        <div class="pa-5 primary text-center text-white">
          <h3 class="tickets-modal__heading">{{ headerName }}</h3>
        </div>

        <v-carousel
          :model-value="tab"
          @update:model-value="tab = $event"
          :continuous="tickets.length > 1"
          height="auto"
          hide-delimiters
          :show-arrows="tickets.length > 1"
        >
          <div>
            <v-carousel-item
              v-for="ticket in tickets"
              :key="`ticket-${ticket.id}-${ticket.order_product_id}`"
              eager
            >
              <div class="align-items-center d-flex flex-column pt-0 barcode-container">
                <div v-if="ticket.attributeName" class="primary text-center text-white pb-2">
                  <h5>{{ ticket.attributeName }}</h5>
                  <h6 class="mt-1 text-caption">{{ ticket.attributeSubtitle }}</h6>
                </div>

                <div
                  v-if="ticket.redeemed || ticket.start_date"
                  class="px-4 primary text-center text-white"
                >
                  <v-divider class="mb-4" dark />
                  <vac
                    :ref="`ticketTimer-${ticket.order_product_id}`"
                    :left-time="ticket.timer"
                    @finish="$emit('hide-ticket')"
                  >
                    <template #process="{ timeObj }">
                      <div class="text-center mb-2 text-caption">
                        Expires in:
                        <span class="font-weight-bold">
                          <span v-if="parseInt(timeObj.d, 10) > 0">
                            {{ `${timeObj.d}d ` }}
                          </span>
                          <span
                            v-if="parseInt(timeObj.d, 10) > 0 || parseInt(timeObj.h, 10) > 0"
                          >
                            {{ `${parseInt(timeObj.h, 10)}h ` }}
                          </span>
                          <span
                            v-if="
                              parseInt(timeObj.d, 10) > 0 ||
                              parseInt(timeObj.h, 10) > 0 ||
                              parseInt(timeObj.m, 10) > 0
                            "
                          >
                            {{ `${parseInt(timeObj.m, 10)}m ` }}
                          </span>
                          {{ `${parseInt(timeObj.s, 10)}s` }}
                        </span>
                      </div>
                    </template>
                  </vac>

                  <div
                    v-if="ticket.start_date"
                    :class="`text-center text-caption ${!showRedeemedOn(ticket) ? 'mb-4' : ''}`"
                  >
                    For use on {{ localScheduledDate(ticket.start_date) }}
                  </div>
                  <div
                    v-if="showRedeemedOn(ticket)"
                    class="mb-4 text-center text-caption"
                  >
                    Redeemed on {{ localRedeemedDate(ticket.redeemed) }}
                  </div>
                </div>

                <!-- Ticket content -->
                <div class="pt-4 white">
                  <div
                    v-if="ticket.line_1"
                    class="px-4 text-body-2 text-center"
                  >
                    {{ ticket.line_1 }}
                  </div>

                  <!-- Voucher not delivered yet -->
                  <div
                    v-if="isVoucherPending(ticket)"
                    class="py-4 text-center"
                  >
                    <div
                      class="barcode-container__pending pa-4 rounded-xl"
                      :class="tickets.length > 1 ? 'mx-10' : 'mx-4'"
                    >
                      <icon
                        class="d-block mx-auto mb-3"
                        fill="primary, primary"
                        height="32"
                        width="32"
                      >
                        hour-glass
                      </icon>
                      <h6 class="mb-2">The voucher will be available soon</h6>                      
                    </div>
                  </div>

                  <div v-else class="py-4 text-center">
                    <template v-if="ticket.type === 'promo_code'">
                      <h6 class="mb-2 text-center">Redemption Code</h6>
                      <div
                        id="product_ticketsmodal_redemption_code_copy"
                        :class="`barcode-container__promo-code mb-2 rounded-pill d-flex ${
                          isCodeCopied(ticket.order_product_id) ? 'text-success' : 'text-primary gtm-click'
                        } ${tickets.length > 1 ? 'mx-10' : 'mx-4'}`"
                        @click="copyCode(ticket.order_product_id)"
                      >
                        <span
                          class="flex-grow-1 py-3 pe-0"
                          :style="`padding-left: ${
                            hasPromoCodes && ticket.redemptionMode === 'Online' ? '54px' : 0
                          }; word-break: break-word;`"
                        >
                          {{ isCodeCopied(ticket.order_product_id) ? 'COPIED' : ticket.value }}
                        </span>
                        <template v-if="hasPromoCodes && ticket.redemptionMode === 'Online'">
                          <v-btn
                            class="px-3 rounded-r-pill"
                            :color="isCodeCopied(ticket.order_product_id) ? 'success' : 'primary'"
                            size="large"
                            style="top: 1px; right: 1px; min-width: 54px;"
                            variant="text"
                            tile
                          >
                            
                              <icon
                                v-if="isCodeCopied(ticket.order_product_id)"
                                :key="`copied-btn-${ticket.id}`"
                                fill="rgb(var(--v-theme-success))"
                              >
                                copied
                              </icon>
                              <icon
                                v-else
                                :key="`copy-btn-${ticket.id}`"
                                fill="rgb(var(--v-theme-primary))"
                              >
                                copy
                              </icon>
                            
                          </v-btn>
                        </template>
                      </div>
                    </template>

                    <template v-if="ticket.redemptionMode === 'Online'">
                      <div :class="tickets.length > 1 ? 'px-10' : 'px-4'">
                        <v-btn
                          id="product_ticketsmodal_redemption_website_lnk"
                          class="gtm-click show-modal-popup__btn"
                          color="primary"
                          :href="ticket.redemptionWebsite"
                          size="large"
                          rounded="lg"
                          target="_blank"
                          width="100%"
                        >
                          Go To Website
                        </v-btn>
                      </div>
                    </template>

                    <template v-if="ticket.redemptionMode === 'Phone'">
                      <div :class="tickets.length > 1 ? 'px-10' : 'px-4'">
                        <v-btn
                          id="product_ticketsmodal_redemption_phone_lnk"
                          class="gtm-click show-modal-popup__btn"
                          color="primary"
                          :href="`tel:${ticket.redemptionPhone.replace(/\D/g,'')}`"
                          size="large"
                          rounded="lg"
                          width="100%"
                        >
                          Call To Redeem
                        </v-btn>
                        <div class="font-weight-bold text-center text-body-2 mt-2">
                          Call: {{ ticket.redemptionPhone }}
                        </div>
                      </div>
                    </template>

                    <!-- HTML Ticket -->
                    <template v-if="shouldShowRedemptionInstructions(ticket)">
                      <h6 class="mb-2 text-center">Redemption Instructions:</h6>
                      <div
                        class="barcode-container__html pa-4 rounded-xl text-left"
                        :class="tickets.length > 1 ? 'mx-10' : 'mx-4'"
                      >
                        <div
                          v-if="ticket.redemptionInstructions"
                          v-html="ticket.redemptionInstructions"
                        ></div>
                        <hr
                          v-if="shouldShowRedemptionInstructionsSeparator(ticket)"
                          class="my-4 opacity-50 w-100 v-divider theme--light"
                        />
                        <div
                          v-if="shouldShowRedemptionInstructionsTicket(ticket)"
                          v-html="ticket.value"
                        ></div>
                      </div>
                    </template>

                    <!-- Barcode Ticket -->
                    <template
                      v-if="ticket.type === 'barcode' && ticket.barcode_type === 'QRCODE'"
                    >
                      <img
                        alt="ticket qr code"
                        class="barcode-container__qrcode mt-4 rounded-lg"
                        :src="`/api/barcode/${ticket.value || ticket.voucher}?type=${ticket.barcode_type}`"
                      />
                      <div class="mb-4 mt-1 text-body-1 barcode-container__num text-center">
                        {{ ticket.value }}{{ ticket.voucher }}
                      </div>
                    </template>

                    <template
                      v-if="ticket.type === 'barcode' && ['C39','C128','EAN13','UPCA'].includes(ticket.barcode_type)"
                    >
                      <img
                        alt="ticket barcode"
                        class="barcode-container__barcode"
                        :src="`/api/barcode/${urlEncode(ticket.value)}?type=${ticket.barcode_type}`"
                      />
                      <div class="d-flex my-1 text-body-2 barcode-container__num">
                        <template v-for="(val, idx) in ticket.value.split('')" :key="`${idx}-val-${ticket.id}`">
                          <div >{{ val }}</div>
                          <div
                            v-if="idx + 1 < ticket.value.split('').length"
                            :key="`${idx}-spacer-${ticket.id}`"
                          ></div>
                        </template>
                      </div>
                    </template>

                    <!-- Image Ticket -->
                    <template v-if="ticket.type === 'image' && ticket.value">
                      <v-img
                        alt="ticket image"
                        class="ma-4"
                        contain
                        :src="ticket.value"
                      ></v-img>
                    </template>

                    <!-- Voucher Ticket -->
                    <template v-if="ticket.type === 'voucher' && ticket.value">
                      <div :class="['mt-4 d-flex justify-center', tickets.length > 1 ? 'px-12' : 'px-4']">
                        <v-btn
                          id="product_ticketsmodal_pdf_voucher_lnk"
                          class="gtm-click show-modal-popup__btn"
                          color="primary"
                          :href="ticket.value"
                          size="large"
                          rounded="lg"
                          rel="noopener noreferrer"
                          target="_blank"
                          :width="tickets.length > 1 ? 'auto' : '100%'"
                          :max-width="tickets.length > 1 ? '260' : undefined"
                          :min-width="tickets.length > 1 ? '200' : undefined"
                        >
                          View Voucher
                        </v-btn>
                      </div>
                    </template>
                  </div>

                  <div
                    v-if="ticket.line_2"
                    class="mb-4 px-4 text-body-2 text-center"
                  >
                    {{ ticket.line_2 }}
                  </div>
                </div>
              </div>
            </v-carousel-item>

            <div
              v-if="tickets.length > 1"
              class="font-weight-bold pa-4 pt-0 text-body-2 text-center white"
            >
              <div class="d-flex justify-center pt-4">
                <template v-for="n in tickets.length" :key="`tab-dot-${n}`">
                  <div                    
                    class="carousel-dot"
                    :class="n - 1 === tab ? 'carousel-dot__active' : ''"
                    @click="tab = n - 1"
                  ></div>
                </template>
              </div>
              <v-divider class="my-4 opacity-30" light></v-divider>
              Swipe left/right to view all tickets.
            </div>
          </div>
        </v-carousel>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ticketHelpers from '../helpers';

export default {
  name: 'TicketsModal',
  props: {
    open: { type: Boolean, default: false },
    product: { type: Object, default: () => ({}) },
    // Optional set of products to show as one combined ticket carousel (e.g. a deal bundling
    // several GoRedeem products). When null/empty the modal is single-product (uses `product`).
    ticketProducts: { type: Array, default: null },
    productType: String
  },
  data() {
    return { showCopied: [], tab: 0 };
  },
  computed: {
    ...mapState('products', ['products']),
    hasPromoCodes() {
      return this.orderProducts.some(op => op?.ticket?.type === 'promo_code');
    },
    hasTime() {
      return ticketHelpers.schedulingWithTimeRequired(this.product);
    },
    modal() {
      if (this.productType === 'admission') return { heading: `Your Ticket${this.tickets.length > 1 ? 's' : ''}`, icon: { fill: 'primary', name: 'experiences' } };
      if (this.productType === 'coupon') return { heading: `Your Coupon${this.tickets.length > 1 ? 's' : ''}`, icon: { fill: 'primary', name: 'coupon' } };
      if (this.productType === 'tasting') return { heading: `Your Voucher${this.tickets.length > 1 ? 's' : ''}`, icon: { fill: 'primary', name: 'tasting' } };
      return { heading: null, icon: null };
    },
    productList() {
      return this.ticketProducts?.length ? this.ticketProducts : [this.product];
    },
    headerName() {
      return this.tickets[this.tab]?.productName || this.product?.name || '';
    },
    orderProducts() {
      return this.productList.flatMap(p => p?.order_products || []);
    },
    redemption() { return this.product?.settings?.redemption || {}; },
    redemptionMode() { return this.product?.redemption_settings?.mode; },
    redeemOnMobile() { return ticketHelpers.redeemOnMobile(this.product); },
    ticketShows() { return ticketHelpers.ticketShows(this.product); },
    tickets() {
      // Flatten active tickets across every product so a deal's GoRedeem tickets share one
      // carousel. Each entry carries its own product's context (name + redemption settings)
      // so a slide never renders another product's settings.
      return this.productList.flatMap(product =>
        ticketHelpers.activeTickets(product).map(({ ticket, redeemed, attribute }) => ({
          attributeName: attribute?.name,
          attributeSubtitle: attribute?.sub_title,
          redeemed,
          productName: product.name,
          redemptionMode: product.redemption_settings?.mode,
          redemptionWebsite: product.redemption_settings?.website,
          redemptionPhone: product.redemption_settings?.phone_number,
          redemptionInstructions: product.redemption_settings?.instructions,
          _product: product,
          ...ticket
        }))
      );
    }
  },
  methods: {
    ...mapActions('orderProducts', ['updateTimers']),
    async copyCode(id) {
      const ticket = this.tickets.find(t => t.order_product_id === id);
      if (this.isCodeCopied(id) || ticket?.redemptionMode !== 'Online') return;
      await navigator.clipboard.writeText(ticket?.value);
      this.showCopied.push(id);
      setTimeout(() => {
        const idx = this.showCopied.indexOf(id);
        if (idx !== -1) this.showCopied.splice(idx, 1);
      }, 5000);
    },
    isCodeCopied(id) { return this.showCopied.includes(id); },
    isVoucherPending(ticket) { return ticketHelpers.voucherPending(ticket); },
    localScheduledDate(date) {
      const format = `MMMM Do, YYYY${this.hasTime ? ', [at] h:mma' : ''}`;
      return this.$getLocalDate(date, format);
    },
    localRedeemedDate(redeemed) { return this.$getLocalDate(redeemed); },
    // Hide "Redeemed on" while the booking is redeemed for a future date/time;
    // only "For use on" should show until that moment is reached.
    showRedeemedOn(ticket) {
      return !!ticket.redeemed && !ticketHelpers.isFutureRedemption(ticket);
    },
    urlEncode(param) { return encodeURIComponent(param); },
    shouldShowRedemptionInstructions(ticket) {
      return (ticket.type === 'html' && ticket.value) || !!(ticket._product || this.product).redemption_settings.instructions;
    },
    shouldShowRedemptionInstructionsTicket(ticket) {
      return ticket.type === 'html' && ticket.value && ticket.value !== (ticket._product || this.product).redemption_settings.instructions;
    },
    shouldShowRedemptionInstructionsSeparator(ticket) {
      return !!(ticket._product || this.product).redemption_settings.instructions && this.shouldShowRedemptionInstructionsTicket(ticket);
    }
  },
  watch: {
    open(val) {
      if (val) this.updateTimers(this.orderProducts);
    }
  },
  created() {
    this.updateTimers(this.orderProducts);
  }
};
</script>

<style lang="scss" scoped>
.redeem-product {
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    border: 2px dashed black;
    top: -3px;
    left: 0;
    width: 100%;
  }

  /* Remove Vuetify 3 button overlay/underlay visuals */
  :deep(.v-btn__overlay),
  :deep(.v-btn__underlay) {
    background-color: transparent;
  }

  & + :deep(.v-tabs-items .v-window__prev),
  & + :deep(.v-tabs-items .v-window__next) {
    background: none !important;
  }
}

.barcode-container {
  &__qrcode {
    margin: 0 auto;
    width: 150px;
  }

  &__barcode {
    height: 75px;
    margin: 0 auto;
    width: min(calc(100vw - 148px), 300px);
  }

  &__num {
    font-weight: bold;
    line-height: 1rem;
    margin: 0 auto;
    width: calc(min(100vw, 480px) - 212px);

    & div:nth-child(even) {
      flex-grow: 1;
    }
  }

  &__promo-code {
    align-items: center !important;
    border: dashed 2px #e5e5e5;
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
  }

  &__html {
    border: solid 1px #e5e5e5;
    color: rgb(var(--v-theme-primary));
    font-size: 0.875rem;
    text-align: center;
  }

  &__pending {
    border: dashed 2px #e5e5e5;
    color: rgb(var(--v-theme-primary));
    font-size: 0.875rem;
    text-align: center;
  }
}

/* Carousel navigation overrides */
:deep(.v-window__next),
:deep(.v-window__prev) {
  background: none !important;
  top: calc(50% - 32px);

  button::after {
    content: '';
    position: absolute;
    inset: 0;
  }
}

:deep(.v-window__next) {
  margin: 0 0.5rem 0 0 !important;

  button::after {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='16' viewBox='0 0 30 30' width='16'%3E%3Cpath d='M 24.775 3.525 L 21.25 0 L 6.25 15 L 21.25 30 L 24.775 26.475 L 13.325 15 Z' fill='black' /%3E%3C/svg%3E");
    background-position: 40% center;
    transform: rotate(180deg);
    transform-origin: center;
  }
}

:deep(.v-window__prev) {
  margin: 0 0 0 0.5rem !important;

  button::after {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='16' viewBox='0 0 30 30' width='16'%3E%3Cpath d='M 24.775 3.525 L 21.25 0 L 6.25 15 L 21.25 30 L 24.775 26.475 L 13.325 15 Z' fill='black' /%3E%3C/svg%3E");
    background-position: 40% center;
  }
}

/* Hide button content (Vuetify 3 safe) */
:deep(.v-window__next .v-btn__content),
:deep(.v-window__prev .v-btn__content) {
  display: none;
}

.carousel-dot {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  cursor: pointer;
  height: 12px;
  width: 12px;
  transition: all 300ms ease-in-out;

  &:not(:first-child) {
    margin-left: 16px;
  }

  &__active {
    background-color: rgb(var(--v-theme-primary));
    box-shadow: 0 0 0 8px rgba(0, 0, 0, 0.05);
  }
}


.redeem_modal-dialog :deep(.v-overlay__content) {
  align-self: center;
  flex: 0 1 auto;
  margin: 0 auto;
  max-height: calc(100vh - 48px);
  max-width: min(480px, calc(100vw - 48px));
  position: relative;
  width: 100%;
  z-index: 2;
}

.redeem_modal-dialog :deep(.redeem_modal-dialog__card) {
  max-width: min(100dvw - 2rem, var(--project-max-width) - 2rem);
  max-height: 95%;
  margin: 0;
}

.v-dialog {
    width: min(100dvw - 2rem, var(--project-max-width) - 2rem);
    width: 100%;
}

.redeem_modal-dialog :deep(.redeem_modal) {
  border-radius: 2rem !important;
}

.text-center.text-white {
  background-color: rgb(var(--v-theme-primary)) !important;
  border-color: rgb(var(--v-theme-primary)) !important;
  color: #ffffff !important;
}

:deep(.v-divider) {
  border-color: rgba(255, 255, 255, 0.12) !important;
  opacity: 1;
}

h6 {
  font-size: 0.875rem !important;
  line-height: 1rem !important;
}

h3.text-center.mb-2 {
  font-size: 1.25rem !important;
  line-height: 1.5625rem !important;
}

.tickets-modal__heading {
  font-size: 1.25rem !important;
  line-height: 1.5625rem !important;
}
.barcode-container__html {
  border-radius: 16px !important;

  :deep(p) {
    padding-bottom: 16px;
  }

  :deep(ol),
  :deep(ul) {
    padding-left: 24px;
  }
}
.show-modal-popup__btn {
  border-radius: 9999px !important;
}
</style>
